import { AboutGridItemType } from "module/types";

export type AboutGridItemLocalizationType = Record<AboutGridItemType, string>;

export const aboutGridItemLocalization_en: AboutGridItemLocalizationType = {
  [AboutGridItemType.Game]: "Game",
  [AboutGridItemType.Module]: "Module",
  [AboutGridItemType.App]: "App",
  [AboutGridItemType.Web]: "Web",
  [AboutGridItemType.Company]: "Company",
  [AboutGridItemType.Outsourcing]: "Outsourcing",
  [AboutGridItemType.Unity]: "Unity",
  [AboutGridItemType.iOS]: "iOS",
  [AboutGridItemType.Android]: "Android",
  [AboutGridItemType.CSharpServer]: "C# Server",
  [AboutGridItemType.SpringBoot]: "Spring Boot",
};

export const aboutGridItemLocalization_ko: AboutGridItemLocalizationType = {
  [AboutGridItemType.Game]: "게임",
  [AboutGridItemType.Module]: "모듈",
  [AboutGridItemType.App]: "앱",
  [AboutGridItemType.Web]: "웹",
  [AboutGridItemType.Company]: "회사",
  [AboutGridItemType.Outsourcing]: "외주",
  [AboutGridItemType.Unity]: "유니티",
  [AboutGridItemType.iOS]: "iOS",
  [AboutGridItemType.Android]: "안드로이드",
  [AboutGridItemType.CSharpServer]: "C# 서버",
  [AboutGridItemType.SpringBoot]: "Spring Boot",
};

export const about_en = [
  "Developer creating contents designed for people to play together.",
  "As a self-taught developer across multiple platforms, I struggled with server-side development, which left many of my projects unfinished.",
  "Now, I’m shifting my focus from self-improvement to building real services.",
  "",
];
export const about_ko = [
  "여럿이 함께 즐길 수 있는 콘텐츠를 만드는 개발자.",
  "여러 플랫폼을 독학으로 개발하였기에",
  "서버에서 어려움을 느끼고 미완성으로 남은 프로젝트가 많습니다만,",
  "이제는 자기계발보다는 실제 서비스를 지향하고 있습니다.",
];
